const E = "unknown", n = "10.17.0", o = `${n}+${E}`;
export {
  o as REPORT_PACKAGE_VERSION
};
